<div class="modal-header">
  <h4 class="modal-title">Menu</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">

  </button>
</div>
<div class="modal-body">
  <form [formGroup]="menuForm" (ngSubmit)="onFormSubmit()" id="ngForm">

    <div class="row">
      <div class="col-md-6">
        <label class="form-label">{{'module'|translate}} <span class="text-danger">*</span></label>
        <ng-select
                [loading]="waitingModule"
                [loadingText]="loading"
                [items]="modules"
                bindLabel="name"
                bindValue="id"
                placeholder="{{'choose a module'|translate}}"
                formControlName="module"
                [ngClass]="{'is-invalid': fc['module'].invalid && isSubmitted}"
                [(ngModel)]="moduleSelected">
        </ng-select>

        <div class="invalid-feedback" *ngIf="fc['module'].errors?.['required']">{{'this field is required'|translate}}</div>
        <div class="invalid-feedback" *ngIf="fc['module'].errors?.['serverError']">
          {{ fc['module'].errors?.['serverError'] }}
        </div>
      </div>

<!--      <div class="col-md-3">-->
<!--        <label class="form-label">Type <span class="text-danger">*</span></label>-->
<!--        <input [readonly]="true" class="form-control form-control-sm" type="text" formControlName="type" [ngClass]="{'is-invalid': fc['type'].invalid && isSubmitted}">-->
<!--      </div>-->
      <div class="col-md-3">
        <label class="form-label">{{'type'|translate}} <span class="text-danger">*</span></label>
        <ng-select
                [items]="types"
                bindLabel="title"
                bindValue="name"
                placeholder="{{'choose a type'|translate}}"
                formControlName="type"
                [ngClass]="{'is-invalid': fc['type'].invalid && isSubmitted}"
                [(ngModel)]="typeSelected"
                [readonly]="true">
        </ng-select>
        <div class="invalid-feedback" *ngIf="fc['type'].errors?.['required']">{{'this field is required'|translate}}</div>
        <div class="invalid-feedback" *ngIf="fc['type'].errors?.['serverError']">
          {{ fc['type'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-3">
        <label class="form-label">{{'position'|translate}} </label>
        <input class="form-control form-control-sm" type="number" placeholder="Ex. 10" formControlName="position" [ngClass]="{'is-invalid': fc['position'].invalid && isSubmitted}">
        <div class="invalid-feedback" *ngIf="fc['position'].errors?.['serverError']">
          {{ fc['position'].errors?.['serverError'] }}
        </div>
      </div>

    </div>

    <div class="row mt-2">
      <div class="col-md-6">
        <label class="form-label">{{'name'|translate}} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm bg-gradient" type="text" placeholder="Ex. Menu" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">This field is required</small>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['minlength']">Name must be at least 3 characters long</div>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['serverError']">
          {{ fc['name'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-6">
        <label class="form-label">{{'icon'|translate}}</label>
        <input class="form-control form-control-sm" type="text" placeholder="Ex. fas fa-user" formControlName="icon" [ngClass]="{'is-invalid': fc['icon'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['icon'].errors?.['required']">This field is required</small>
        <div class="invalid-feedback" *ngIf="fc['icon'].errors?.['serverError']">
          {{ fc['icon'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="row mt-2 d-none">
        <div class="col-md-6">
          <label class="form-label">{{'badge type'|translate}}</label>
          <ng-select
                  [items]="badgeTypes"
                  bindLabel="name"
                  bindValue="name"
                  placeholder="Choose a color"
                  formControlName="badgeType"
                  [ngClass]="{'is-invalid': fc['badgeType'].invalid && isSubmitted}"
                  [(ngModel)]="selectedBadgeTypes">
          </ng-select>
          <div class="invalid-feedback" *ngIf="fc['badgeType'].errors?.['required']">This field is required</div>
          <div class="invalid-feedback" *ngIf="fc['badgeType'].errors?.['serverError']">
            {{ fc['badgeType'].errors?.['serverError'] }}
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">{{'badge value'|translate}}</label>
          <input class="form-control form-control-sm" type="text" placeholder="Ex. 5 / new" formControlName="badgeValue" [ngClass]="{'is-invalid': fc['badgeValue'].invalid && isSubmitted}">
          <small class="invalid-feedback fst-italic" *ngIf="fc['badgeValue'].errors?.['required']">This field is required</small>
          <div class="invalid-feedback" *ngIf="fc['badgeValue'].errors?.['serverError']">
            {{ fc['badgeValue'].errors?.['serverError'] }}
          </div>
        </div>
      </div>
        <div class="row mt-2">
        <div class="col-md-6">
                <label class="form-label">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
                    <div class="btn-radio" >
                        <div class="btn-group" data-bs-toggle="buttons">
                            <div class="btn btn-light txt-dark">
                                <div class="radio radio-dark">
                                    <input id="radio21" formControlName="isEnable" type="radio" value='1'>
                                    <label for="radio21">{{ 'yes'|translate }}</label>
                                </div>
                            </div>
                            <div class="btn btn-light txt-dark">
                                <div class="radio radio-dark">
                                    <input id="radio22" formControlName="isEnable" type="radio" value='0'>
                                    <label for="radio22">{{ 'no'|translate }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
        </div>
      </div>

    </div>


  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>

  <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-outline-primary" [disabled]=saving>
    <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
    <ng-template #isSaving>
      {{ "Submitting" | translate}} ...
    </ng-template>
  </button>

</div>














